export default __webpack_public_path__ + "static/media/regina_demina_1_lowdef.b64cc4c5.png";